import { render, staticRenderFns } from "./CreateShop.vue?vue&type=template&id=6aa9cc07&scoped=true"
import script from "./CreateShop.vue?vue&type=script&lang=js"
export * from "./CreateShop.vue?vue&type=script&lang=js"
import style0 from "./CreateShop.vue?vue&type=style&index=0&id=6aa9cc07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa9cc07",
  null
  
)

export default component.exports